import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const userAddressSelector = ({ userAddress }: ReducerState) => userAddress;
export const userAddressLoadingSelector = createSelector(
  userAddressSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
